import type { FilterOption, VoucherStateFilter } from "./types";

export const voucherStates: FilterOption<VoucherStateFilter>[] = [
  { value: "activated", label: "Activated" },
  { value: "failed", label: "Failed" },
  { value: "issued", label: "Issued" },
  { value: "used", label: "Used" },
  { value: "revoked", label: "Revoked" },
  { value: "exhausted", label: "Exhausted" },
  { value: "expired", label: "Expired" },
];

export const channelOptions: FilterOption<number>[] = [
  { value: 1, label: "API" },
  { value: 2, label: "Distributor Portal" },
  { value: 3, label: "White Label Portal" },
];

export const reconOptions: FilterOption<number>[] = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Failed" },
  { value: 2, label: "Success" },
];
